// Only used for extending!

export default class Carousel {
	constructor(elm) {
		this.elm = elm;

		this.swiperContainer = this.elm.querySelector('[data-swiper-container]');
		this.scrollbar = this.elm.querySelector('[data-swiper-scrollbar]');
		this.prev = this.elm.querySelector('[data-swiper-prev]');
		this.next = this.elm.querySelector('[data-swiper-next]');
	}

	destroy() {
		if (!this.swiper) {
			return;
		}

		this.swiper.destroy(true, true);
	}
}
